import { Modal, TextBase, TextSubHeader } from '@carboncopyco/ui';
import { DemoLinkAccessPolicySelect } from './DemoLinkAccessPolicySelect';
import { DemoLinkEnable } from './DemoLinkEnable';
import { useDemoLinkProps } from './DemoLinkModalContext';
import { DemoLinkPlatformSelect } from './DemoLinkPlatformSelect';
import { DemoLinkRevision } from './DemoLinkRevision';
import { DemoLinkSettings } from './DemoLinkSettings';
import { DemoLinkSubmitAndCopy } from './DemoLinkSubmitAndCopy';

export const DemoLinkModalBody = () => {
  const { onClose, isOpen, assetType, role, enabled, latestRevision, assetId } =
    useDemoLinkProps();
  const isPresenter = role === 'presenter';
  const isEditor = role === 'editor';
  return (
    <Modal
      open={isOpen}
      title={
        <div className="flex items-center">
          <TextSubHeader
            label={`Share ${assetType} internally`}
            color="text-ds-natural-600"
          />
        </div>
      }
      onClose={onClose}
    >
      <div className="flex flex-col gap-3 w-[560px] mt-3">
        <div>
          <div className="flex flex-col gap-6">
            <TextBase
              label={`Create a link for your team members to easily present this ${assetType}.`}
              color="text-ds-natural-600"
            />
            <DemoLinkPlatformSelect
              allowed={!isPresenter}
              disabled={!enabled}
            />
            <DemoLinkAccessPolicySelect
              allowed={!isPresenter}
              disabled={!enabled}
            />
            <DemoLinkSettings
              disabled={!enabled || isPresenter || isEditor}
              demoId={assetId}
            />
            {assetType === 'demo' && (
              <DemoLinkRevision
                latestRevision={Number(latestRevision)}
                disabled={isPresenter || !enabled}
              />
            )}
          </div>
        </div>

        <div className="mt-8">
          <div className="flex justify-center items-center w-full">
            <DemoLinkEnable disabled={isPresenter} />
            <DemoLinkSubmitAndCopy
              allowed={!isPresenter}
              disabled={!enabled}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
